module.exports = __webpack_public_path__ + "img/service-premium-support.ec01e54f.jpg";